import {
    GET_TRUCKS, GET_TRUCKS_ERROR, GET_TRUCKS_SUCCESS,
    GET_CYCLES_CURRENT, GET_CYCLES_CURRENT_ERROR, GET_CYCLES_CURRENT_SUCCESS,
    GET_CYCLES_HISTORY, GET_CYCLES_HISTORY_ERROR, GET_CYCLES_HISTORY_SUCCESS,
} from './Cycles.actions';

const initial = {
    data: [], // trucks
    current: { data: [], loading: false, error: undefined },
    history: { data: [], loading: false, error: undefined },
    loadingTrucks: false,
    errorTrucks: undefined,
};

const cyclesReducer = (state = initial, { payload, type }) => {
    switch (type) {
        /* TRUCKS */
        case GET_TRUCKS:
            return { ...state, loadingTrucks: true, errorTrucks: undefined };
        case GET_TRUCKS_ERROR:
            return { ...state, loadingTrucks: false, errorTrucks: payload.error };
        case GET_TRUCKS_SUCCESS:
            return { ...state, loadingTrucks: false, errorTrucks: undefined, data: payload.data };

        /* CURRENT */
        case GET_CYCLES_CURRENT:
            return { ...state, current: { ...state.current, loading: true, error: undefined } };
        case GET_CYCLES_CURRENT_ERROR:
            return { ...state, current: { ...state.current, loading: false, error: payload.error } };
        case GET_CYCLES_CURRENT_SUCCESS:
            return { ...state, current: { data: payload.data, loading: false, error: undefined } };

        /* HISTORY */
        case GET_CYCLES_HISTORY:
            return { ...state, history: { ...state.history, loading: true, error: undefined } };
        case GET_CYCLES_HISTORY_ERROR:
            return { ...state, history: { ...state.history, loading: false, error: payload.error } };
        case GET_CYCLES_HISTORY_SUCCESS:
            return { ...state, history: { data: payload.data, loading: false, error: undefined } };

        default:
            return state;
    }
};

export default cyclesReducer;